package com.macrofocus.eflux.components.link

import kotlinx.browser.window
import mui.material.Button
import mui.material.Link
import mui.system.sx
import org.locationtech.jts.geom.Geometry
import react.FC
import react.Props
import web.cssom.None
import web.cssom.px

external interface GoogleStreetViewLinkProps : Props {
    var geometry: Geometry?
}

val GoogleStreetViewLink = FC<GoogleStreetViewLinkProps> { props ->
    Link {
        sx {
            textTransform = None.none
            paddingTop = 0.px
            paddingBottom = 0.px
        }

        component = Button
        onClick = {
            val physicalGeometry = props.geometry
            if(physicalGeometry != null) {
                val url = "https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${physicalGeometry.centroid.y},${physicalGeometry.centroid.x}"
                window.open(url, "_blank")
            }
        }

        +"Google Street View"
    }
}